import Layout from "../../views/feature/components/Layout.vue";
const RouterView = {
  render: h => h("router-view")
};
const routes = [
  {
    path: "/feature-:site",
    component: Layout,
    children: [
      {
        path: "/",
        component: () =>
          import(
            /* webpackChunkName: "hst_home" */ "../../views/feature/home/index.vue"
          )
      },
      {
        path: "share-page",
        component: () =>
          import(
            /* webpackChunkName: "hst_home" */ "../../views/feature/home/share-page.vue"
          )
      },
      {
        path: "column",
        component: RouterView,
        children: [
          {
            path: "detail/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_column_detail" */ "../../views/feature/column/detail.vue"
              )
          },
          {
            path: "list/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_column_list" */ "../../views/feature/column/list.vue"
              )
          }
        ]
      },
      {
        path: "company",
        component: RouterView,
        children: [
          {
            path: "home/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_company" */ "../../views/feature/company/index.vue"
              )
          },
          {
            path: "info/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_company_info" */ "../../views/feature/company/info.vue"
              )
          },
          {
            path: "product/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_company_product" */ "../../views/feature/company/product.vue"
              )
          },
          {
            path: "mentor", // 这里是企业的id
            component: RouterView,
            children: [
              {
                path: "list/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_company_product" */ "../../views/feature/company/mentor/index.vue"
                  )
              },
              {
                path: "detail/:id", // 这里是导师ID
                component: () =>
                  import(
                    /* webpackChunkName: "hst_company_product" */ "../../views/feature/company/mentor/detail.vue"
                  )
              }
            ]
          }
        ]
      },
      {
        path: "intro",
        redirect: "intro/base",
        component: RouterView,
        children: [
          {
            path: "base",
            component: RouterView,
            children: [
              {
                path: "/",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_intro_base" */ "../../views/feature/introduction/index.vue"
                  )
              },
              {
                path: "info",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_intro_base_info" */ "../../views/feature/introduction/base/info.vue"
                  )
              },
              {
                path: "environment",
                component: () =>
                  import(
                    "../../views/feature/introduction/base/environment.vue"
                  )
              }
            ]
          },
          {
            path: "coop",
            component: () =>
              import(
                /* webpackChunkName: "hst_intro_pro_coop" */ "../../views/feature/introduction/index.vue"
              )
          },
          {
            path: "talent",
            component: () =>
              import(
                /* webpackChunkName: "hst_intro_pro_coop" */ "../../views/feature/introduction/index.vue"
              )
          }
        ]
      },
      {
        path: "major",
        component: RouterView,
        children: [
          {
            path: "/",
            component: () =>
              import(
                /* webpackChunkName: "hst_intro_pro" */ "../../views/feature/major/index.vue"
              )
          },
          {
            path: "info",
            component: () =>
              import(
                /* webpackChunkName: "hst_intro_pro_info" */ "../../views/feature/major/info.vue"
              )
          },
          {
            path: "materials",
            component: () => import("../../views/feature/major/materials.vue")
          },
          {
            path: "relative/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_intro_pro_relative" */ "../../views/feature/major/relative.vue"
              )
          },
          {
            path: "mentor",
            component: RouterView,
            children: [
              {
                path: "list",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_intro_pro_mentor_list" */ "../../views/feature/major/mentor/index.vue"
                  )
              },
              {
                path: "detail/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_intro_pro_mentor_detail" */ "../../views/feature/major/mentor/detail.vue"
                  )
              }
            ]
          },
          {
            path: "course",
            component: RouterView,
            children: [
              {
                path: "list",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_intro_pro_course_list" */ "../../views/feature/major/course/index.vue"
                  )
              },
              {
                path: "detail/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_intro_pro_course_detail" */ "../../views/feature/major/course/detail.vue"
                  )
              }
            ]
          },
          {
            path: "job",
            component: RouterView,
            children: [
              {
                path: "list",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_intro_pro_job_list" */ "../../views/feature/major/job/index.vue"
                  )
              },
              {
                path: "detail/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_intro_pro_job_detail" */ "../../views/feature/major/job/detail.vue"
                  )
              }
            ]
          }
        ]
      },
      {
        path: "council",
        redirect: "council/info/Structure",
        component: RouterView,
        children: [
          {
            path: "info/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_intro_base_director" */ "../../views/feature/council/index.vue"
              )
          },
          {
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_intro_base_directorDetail" */ "../../views/feature/council/detail.vue"
              )
          },
          {
            path: "list",
            component: () =>
              import(
                /* webpackChunkName: "hst_intro_base_directorList" */ "../../views/feature/council/list.vue"
              )
          }
        ]
      },
      {
        path: "ah",
        redirect: "ah/admission",
        component: RouterView,
        children: [
          {
            path: "admission",
            meta: {
              authorization: true
            },
            component: () =>
              import(
                /* webpackChunkName: "hst_ah" */ "../../views/feature/admissionsHiring/index.vue"
              )
          },
          {
            path: "hiring",
            component: () =>
              import(
                /* webpackChunkName: "hst_ah" */ "../../views/feature/admissionsHiring/index.vue"
              )
          },

          {
            path: "job",
            component: RouterView,
            children: [
              {
                path: "detail/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ah" */ "../../views/feature/admissionsHiring/job/detail.vue"
                  )
              },
              {
                path: "chat",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ah" */ "../../views/feature/admissionsHiring/job/chat.vue"
                  )
              }
            ]
          },
          {
            path: "preach",
            component: RouterView,
            children: [
              {
                path: "list",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ah_preach_list" */ "../../views/feature/admissionsHiring/preach/index.vue"
                  )
              },
              {
                path: "detail/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ah_preach_detail" */ "../../views/feature/admissionsHiring/preach/detail.vue"
                  )
              }
            ]
          },
          {
            path: "column",
            component: RouterView,
            children: [
              {
                path: "job",
                component: RouterView,
                children: [
                  {
                    path: "list",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ah_column_list" */ "../../views/feature/admissionsHiring/column/job/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ah_column_list" */ "../../views/feature/admissionsHiring/column/job/detail.vue"
                      )
                  }
                ]
              },
              {
                path: "meeting",
                component: RouterView,
                children: [
                  {
                    path: "list",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ah_column_list" */ "../../views/feature/admissionsHiring/column/meeting/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ah_column_list" */ "../../views/feature/admissionsHiring/column/meeting/detail.vue"
                      )
                  }
                ]
              },
              {
                path: "recruit",
                component: RouterView,
                children: [
                  {
                    path: "list",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ah" */ "../../views/feature/admissionsHiring/column/recruit/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ah" */ "../../views/feature/admissionsHiring/column/recruit/detail.vue"
                      )
                  }
                ]
              },
              {
                path: "list/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ah_column_list" */ "../../views/feature/admissionsHiring/column/index.vue"
                  )
              },
              {
                path: "detail/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ah_column_detail" */ "../../views/feature/admissionsHiring/column/detail.vue"
                  )
              }
            ]
          },
          {
            path: "admission",
            component: RouterView,
            children: [
              {
                path: "list/:name",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ah_column_list" */ "../../views/feature/admissionsHiring/admission/index.vue"
                  )
              },
              {
                path: "detail/:name",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ah_column_detail" */ "../../views/feature/admissionsHiring/admission/detail.vue"
                  )
              }
            ]
          }
        ]
      },
      {
        path: "ss",
        redirect: "ss/society",
        component: RouterView,
        children: [
          {
            path: "society",
            component: RouterView,
            children: [
              {
                path: "",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_society" */ "../../views/feature/socialServices/index.vue"
                  )
              },
              {
                path: "consult",
                component: RouterView,
                children: [
                  {
                    path: "list/:type",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_society_consult" */ "../../views/feature/socialServices/consult/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_society_consult_detail" */ "../../views/feature/socialServices/consult/detail.vue"
                      )
                  }
                ]
              },
              {
                path: "training",
                component: RouterView,
                children: [
                  {
                    path: "list",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_society_training" */ "../../views/feature/socialServices/training/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_society_training_detail" */ "../../views/feature/socialServices/preach/detail.vue"
                      )
                  }
                ]
              }
            ]
          },
          {
            path: "support",
            component: RouterView,
            children: [
              {
                path: "",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_support" */ "../../views/feature/socialServices/index.vue"
                  )
              },
              {
                path: "faq",
                component: RouterView,
                children: [
                  {
                    path: "",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_support" */ "../../views/feature/socialServices/fqa/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_support" */ "../../views/feature/socialServices/fqa/detail.vue"
                      )
                  }
                ]
              },
              {
                path: "question",
                component: RouterView,
                children: [
                  {
                    path: "",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_support" */ "../../views/feature/socialServices/askquestion/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_support" */ "../../views/feature/socialServices/askquestion/detail.vue"
                      )
                  }
                ]
              }
            ]
          },
          {
            path: "expert",
            component: RouterView,
            children: [
              {
                path: "",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_expert" */ "../../views/feature/socialServices/index.vue"
                  )
              },
              {
                path: "list",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_expert" */ "../../views/feature/socialServices/expert/index.vue"
                  )
              },
              {
                path: "detail/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_expert" */ "../../views/feature/socialServices/expert/detail.vue"
                  )
              },
              {
                path: "chat",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_expert" */ "../../views/feature/socialServices/expert/chat.vue"
                  )
              }
            ]
          },
          {
            path: "job",
            component: RouterView,
            children: [
              {
                path: "detail/:id",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_expert" */ "../../views/feature/socialServices/practiceJob/detail.vue"
                  )
              },
              {
                path: "list",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_expert" */ "../../views/feature/socialServices/practiceJob/index.vue"
                  )
              }
            ]
          },
          {
            path: "effect",
            component: RouterView,
            children: [
              {
                path: "",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_effect" */ "../../views/feature/socialServices/index.vue"
                  )
              },
              {
                path: "exam",
                component: RouterView,
                children: [
                  {
                    path: "list",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_effect" */ "../../views/feature/socialServices/exam/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_ss_effect" */ "../../views/feature/socialServices/exam/detail.vue"
                      )
                  }
                ]
              },
              {
                path: "qslist",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_ss_effect" */ "../../views/feature/socialServices/questionnaire/index.vue"
                  )
              }
            ]
          }
        ]
      },
      {
        path: "innovation",
        component: RouterView,
        children: [
          {
            path: "",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/index.vue"
              )
          },
          {
            path: "create",
            meta: {
              authorization: true
            },
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/create.vue"
              )
          },
          {
            path: "detail/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/detail.vue"
              )
          },

          {
            path: "list/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/list.vue"
              )
          },
          {
            path: "mentor-list",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/mentor/index.vue"
              )
          },
          {
            path: "mentor-detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/mentor/detail.vue"
              )
          },
          {
            path: "investor-list",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/investor/index.vue"
              )
          },
          {
            path: "investor-detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/investor/detail.vue"
              )
          },
          {
            path: "investor-create",
            meta: { authorization: true },
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/investor.vue"
              )
          },
          {
            path: "sc-column",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation_sc" */ "../../views/feature/innovation/sc-column.vue"
              )
          },
          {
            path: "sc-detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation_sc_detail" */ "../../views/feature/innovation/sc-detail.vue"
              )
          },
          {
            path: "rz-column",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation_rz" */ "../../views/feature/innovation/rz-column.vue"
              )
          },
          {
            path: "rz-detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation_rz_detail" */ "../../views/feature/innovation/rz-detail.vue"
              )
          },
          {
            path: "match-list",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation_sc_detail" */ "../../views/feature/innovation/match/index.vue"
              )
          },
          {
            path: "match-detail/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/match/detail.vue"
              )
          },
          {
            path: "roadshow-list",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/roadshow/index.vue"
              )
          },
          {
            path: "roadshow-detail/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/roadshow/detail.vue"
              )
          },
          {
            path: "league-list",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/league/index.vue"
              )
          },
          {
            path: "league-detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/innovation/league/detail.vue"
              )
          }
        ]
      },
      {
        path: "achievement",
        redirect: "achievement/show",
        component: RouterView,
        children: [
          {
            path: "show",
            component: RouterView,
            children: [
              {
                path: "",
                component: () =>
                  import(
                    /* webpackChunkName: "hst_achievement" */ "../../views/feature/achievement/index.vue"
                  )
              },
              {
                path: "expert",
                component: RouterView,
                children: [
                  {
                    path: "list",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_achievement" */ "../../views/feature/achievement/expert/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_achievement" */ "../../views/feature/achievement/expert/detail.vue"
                      )
                  }
                ]
              },
              {
                path: "research",
                component: RouterView,
                children: [
                  {
                    path: "list",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_achievement" */ "../../views/feature/achievement/research/index.vue"
                      )
                  },
                  {
                    path: "detail/:id",
                    component: () =>
                      import(
                        /* webpackChunkName: "hst_achievement" */ "../../views/feature/achievement/research/detail.vue"
                      )
                  }
                ]
              }
            ]
          },
          {
            path: "policy-detail/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/achievement/policy/detail.vue"
              )
          },
          {
            path: "policy-list/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/achievement/policy/index.vue"
              )
          },
          {
            path: "show-detail/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/achievement/show/detail.vue"
              )
          },
          {
            path: "show-list/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/achievement/show/index.vue"
              )
          },
          {
            path: "industry",
            component: () =>
              import(
                /* webpackChunkName: "hst_achievement" */ "../../views/feature/achievement/index.vue"
              )
          },
          {
            path: "prefer-firm-detail/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/achievement/firm/detail.vue"
              )
          },
          {
            path: "prefer-firm-list/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/achievement/firm/index.vue"
              )
          },
          {
            path: "production-detail/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/achievement/production/detail.vue"
              )
          },
          {
            path: "production-list/:name",
            component: () =>
              import(
                /* webpackChunkName: "hst_innovation" */ "../../views/feature/achievement/production/index.vue"
              )
          }
        ]
      }
    ]
  }
];

export default routes;
